import { render, staticRenderFns } from "./SvgArrowRight.vue?vue&type=template&id=5189059a&"
import script from "./SvgArrowRight.vue?vue&type=script&lang=js&"
export * from "./SvgArrowRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports